import { Theme } from '@mui/material/styles'

const CLOSED_SIDEBAR_WIDTH = 55
const SIDEBAR_WIDTH = 230

export const sideNavBasicHeaderBox = {
  display: 'flex',
  flexShrink: 0,
  height: '74px',
  boxShadow:
    '0px 4px 6px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(238, 237, 237, 0.05)',
  position: 'relative',
}

export const navHeaderBox = {
  ...sideNavBasicHeaderBox,
  width: '100%',
}

export const shrinkedNavHeaderBox = {
  ...sideNavBasicHeaderBox,
}

export const navLogoBox = {
  display: 'flex',
  justifyContent: 'center',
  width: '70px',
}

export const navTitleBox = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
}

export const resizeBtnBox = {
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  height: '100%',
  width: '100%',
  justifyContent: 'flex-end',
}

export const basicIconBtn = {
  color: 'white',
  bgcolor: (theme: Theme) => theme.palette.primary.main,
  '&:hover': {
    bgcolor: (theme: Theme) => theme.palette.primary.dark,
  },
}

export const shrinkIconBtn = {
  ...basicIconBtn,
  left: '15px',
  width: '30px',
  height: '30px',
}

export const wideIconBtn = {
  ...basicIconBtn,
  left: '15px',
}

export const sideNavBasicMainBox = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  backgroundColor: (theme: Theme) => theme.palette.primary.main,
  flexShrink: 0,
  transition: 'width 0.3s',
}

export const sideNavWideMainBox = {
  ...sideNavBasicMainBox,
  width: SIDEBAR_WIDTH,
}

export const sideNavShrinkedMainBox = {
  ...sideNavBasicMainBox,
  width: CLOSED_SIDEBAR_WIDTH,
}

export const sideNavBasicBodyBox = {
  display: 'flex',
  height: '100%',
}

export const sideNavBodyBox = {
  ...sideNavBasicBodyBox,
  width: '75%',
}

export const sideNavShrinkedBodyBox = {
  ...sideNavBasicBodyBox,
  bgcolor: (theme: Theme) => theme.palette.primary.dark,
}

export const secondItemsList = {
  width: '100%',
  alignItems: 'flex-start',
  paddingLeft: '14px',
}

export const typographyStyle = {
  fontSize: '12px',
  fontWeight: '500',
}

export const titleTypographyStyle = {
  fontWeight: '600',
}

export const menuOptionsTypography = {
  lineHeight: '16px',
  fontWeight: '600',
  color: '#fff',
  fontSize: '0.9rem',
}

export const siteMenuTypography = {
  fontSize: '12px',
  fontWeight: '500',
}

export const userNameMenuTypography = {
  lineHeight: '14px',
  fontWeight: '700',
  color: '#fff',
}

export const userEmailMenuTypography = {
  lineHeight: '14px',
  fontWeight: '300',
  fontSize: '11px',
  color: '#fff',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export const lockIcon = {
  marginLeft: '5px',
}

export const boxWrappingLockIcon = {
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export const companyAvatarStyle = {
  marginBottom: '5px',
}
